"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames3 = _interopRequireDefault(require("classnames"));

var _config = require("./config");

var _lunaButton = _interopRequireWildcard(require("../luna-button"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LunaModal = _react["default"].forwardRef(function (props, ref) {
  var children = props.children,
      overlayClassName = props.overlayClassName,
      className = props.className,
      size = props.size,
      type = props.type,
      id = props.id,
      isOpen = props.isOpen,
      title = props.title,
      onClose = props.onClose,
      closeOnEscape = props.closeOnEscape,
      header = props.header,
      footer = props.footer,
      onPrimaryAction = props.onPrimaryAction,
      primaryActionProps = props.primaryActionProps,
      primaryLabel = props.primaryLabel,
      onSecondaryAction = props.onSecondaryAction,
      secondaryActionProps = props.secondaryActionProps,
      secondaryLabel = props.secondaryLabel,
      other = props.other;

  var getOverlayClassList = function getOverlayClassList() {
    var _classnames;

    var overlay = _config.classes.overlay,
        open = _config.classes.open;
    return (0, _classnames3["default"])((_classnames = {}, _defineProperty(_classnames, overlay, true), _defineProperty(_classnames, open, isOpen), _classnames), overlayClassName);
  };

  var modalContentRef = _react["default"].createRef();

  var onOverlayClick = function onOverlayClick(e) {
    if (modalContentRef.current.contains(e.target)) {
      return;
    }

    onClose(e);
  };

  var getModalClassList = function getModalClassList() {
    var _classnames2;

    var base = _config.classes.base,
        sizes = _config.classes.sizes,
        types = _config.classes.types;
    return (0, _classnames3["default"])((_classnames2 = {}, _defineProperty(_classnames2, base, true), _defineProperty(_classnames2, sizes.modal40, size === _config.LunaModalSizes.modal40), _defineProperty(_classnames2, sizes.modal80, size === _config.LunaModalSizes.modal80), _defineProperty(_classnames2, sizes.modal100, size === _config.LunaModalSizes.modal100), _defineProperty(_classnames2, types.tall80, type === _config.LunaModalTypes.tall80), _defineProperty(_classnames2, types.wide80, type === _config.LunaModalTypes.wide80), _classnames2), className);
  };

  var getHeader = function getHeader() {
    return _react["default"].createElement("header", {
      className: "luna-modal--header"
    }, _react["default"].createElement("div", {
      className: "luna-modal--header_title"
    }, title && _react["default"].createElement("h1", {
      className: "luna-type-header-45"
    }, title), header), _react["default"].createElement("div", {
      className: "luna-modal--header_utility"
    }, _react["default"].createElement("button", {
      "aria-label": "Save and close modal",
      className: "luna-modal--close",
      "data-close": "",
      onClick: onClose
    })));
  };

  var getSecondaryAction = function getSecondaryAction() {
    var Action = null;

    if (onSecondaryAction) {
      if (secondaryActionProps.onClick) {
        throw new TypeError('Luna Modal: The onClick prop was passed to secondaryActionProps, please use onSecondaryAction instead.');
      }

      Action = _react["default"].createElement(_lunaButton["default"], _extends({}, secondaryActionProps, {
        type: _lunaButton.ButtonTypes.secondary,
        className: "luna-modal--action luna-modal--action_secondary luna-container-margin-right-10",
        onClick: onSecondaryAction
      }), secondaryLabel);
    }

    return Action;
  };

  var getPrimaryAction = function getPrimaryAction() {
    var Action = null;

    if (onPrimaryAction) {
      if (primaryActionProps.onClick) {
        throw new TypeError('Luna Modal: The onClick prop was passed to primaryActionProps, please use onPrimaryAction instead.');
      }

      Action = _react["default"].createElement(_lunaButton["default"], _extends({}, primaryActionProps, {
        type: _lunaButton.ButtonTypes.primary,
        className: "luna-modal--action luna-modal--action_primary",
        onClick: onPrimaryAction
      }), primaryLabel);
    }

    return Action;
  };

  var getFooter = function getFooter() {
    return _react["default"].createElement("footer", {
      className: "luna-modal--footer"
    }, getSecondaryAction(), getPrimaryAction(), footer);
  };

  var getContent = function getContent() {
    var modalClasses = getModalClassList();

    if (_config.LunaModalSizes.modal100 !== size) {
      return _react["default"].createElement("div", {
        className: modalClasses,
        ref: modalContentRef
      }, getHeader(), _react["default"].createElement("div", {
        className: "luna-modal--content"
      }, children), getFooter());
    }

    return _react["default"].createElement("div", {
      className: modalClasses,
      ref: modalContentRef
    }, children);
  };

  (0, _react.useEffect)(function () {
    var onKeyUp = function onKeyUp(e) {
      var escKey = 27;

      if (e.which === escKey) {
        onClose(e);
      }
    };

    if (isOpen && closeOnEscape) {
      global.addEventListener('keyup', onKeyUp);
    }

    if (isOpen) {
      document.body.classList.add(_config.classes.bodyOpen);
    }

    return function () {
      global.removeEventListener('keyup', onKeyUp);
      document.body.classList.remove(_config.classes.bodyOpen);
    };
  });
  return _react["default"].createElement("section", _extends({}, other, {
    className: getOverlayClassList(),
    onClick: onOverlayClick,
    ref: ref,
    id: id
  }), getContent());
});

LunaModal.displayName = 'LunaModal';
LunaModal.ENUMS = _config.ENUMS;
LunaModal.propTypes = {
  className: _propTypes["default"].string,
  overlayClassName: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(_config.LunaModalSizes)),
  type: _propTypes["default"].oneOf(Object.values(_config.LunaModalTypes)),
  id: _propTypes["default"].string,
  isOpen: _propTypes["default"].bool,
  title: _propTypes["default"].string,
  onClose: _propTypes["default"].func,
  closeOnEscape: _propTypes["default"].bool,
  header: _propTypes["default"].node,
  footer: _propTypes["default"].node,
  onPrimaryAction: _propTypes["default"].func,
  primaryActionProps: _propTypes["default"].object,
  primaryLabel: _propTypes["default"].string,
  onSecondaryAction: _propTypes["default"].func,
  secondaryActionProps: _propTypes["default"].object,
  secondaryLabel: _propTypes["default"].string
};
LunaModal.defaultProps = {
  isOpen: false,
  size: _config.LunaModalSizes.modal40,
  type: _config.LunaModalTypes["default"],
  primaryActionProps: {},
  secondaryActionProps: {},
  primaryLabel: 'Save',
  secondaryLabel: 'Cancel',
  closeOnEscape: true,
  other: {}
};
var _default = LunaModal;
exports["default"] = _default;
